// Old profile, coupon and comparison URLs of vendors we no longer list. App.tsx turns each entry
// into a <HardRedirect>, and scripts/generate-prerender-stubs.mjs reads this file to write the
// matching redirect stub that crawlers get, so keep exactly one "from": "to" pair per line.
// A comparison page goes to the vendor that is still listed, or to /vendors when neither is.
export const RETIRED_VENDOR_REDIRECTS: Record<string, string> = {
  // VANDL Labs rebranded to Half Nattys, 2026-10-07
  "/vendors/vandl-labs": "/vendors/halfnattys",
  "/vendor/vandl-labs": "/vendors/halfnattys",
  "/coupons/vendor/vandl-labs": "/coupons/vendor/halfnattys",
  // Adera, retired 2026-06-29
  "/vendors/adera": "/vendors",
  "/vendor/adera": "/vendors",
  "/coupons/vendor/adera": "/coupons",
  "/compare/vendors/adera-vs-ion-peptide": "/vendors/ion-peptide",
  "/compare/vendors/adera-vs-limitless-biochem": "/vendors/limitless-biochem",
  "/compare/vendors/adera-vs-optimum-formula": "/vendors/optimum-formula",
  "/compare/vendors/adera-vs-researchchemhq": "/vendors/researchchemhq",
  "/compare/vendors/adera-vs-vandl-labs": "/vendors/halfnattys",
  "/compare/vendors/adera-vs-getmelts": "/vendors",
  "/compare/vendors/adera-vs-nova-peptides": "/vendors",
  "/compare/vendors/adera-vs-paramount-peptides": "/vendors",

  // Nova Peptide Supply and Paramount Peptides, deactivated before 2026-09-10
  "/vendors/nova-peptides": "/vendors",
  "/vendor/nova-peptides": "/vendors",
  "/coupons/vendor/nova-peptides": "/coupons",
  "/vendors/paramount-peptides": "/vendors",
  "/vendor/paramount-peptides": "/vendors",
  "/coupons/vendor/paramount-peptides": "/coupons",
  "/compare/vendors/ion-peptide-vs-nova-peptides": "/vendors/ion-peptide",
  "/compare/vendors/ion-peptide-vs-paramount-peptides": "/vendors/ion-peptide",
  "/compare/vendors/limitless-biochem-vs-nova-peptides": "/vendors/limitless-biochem",
  "/compare/vendors/limitless-biochem-vs-paramount-peptides": "/vendors/limitless-biochem",
  "/compare/vendors/nova-peptides-vs-optimum-formula": "/vendors/optimum-formula",
  "/compare/vendors/optimum-formula-vs-paramount-peptides": "/vendors/optimum-formula",
  "/compare/vendors/nova-peptides-vs-researchchemhq": "/vendors/researchchemhq",
  "/compare/vendors/paramount-peptides-vs-researchchemhq": "/vendors/researchchemhq",
  "/compare/vendors/nova-peptides-vs-vandl-labs": "/vendors/halfnattys",
  "/compare/vendors/paramount-peptides-vs-vandl-labs": "/vendors/halfnattys",
  "/compare/vendors/nova-peptides-vs-paramount-peptides": "/vendors",
  "/compare/vendors/getmelts-vs-nova-peptides": "/vendors",
  "/compare/vendors/getmelts-vs-paramount-peptides": "/vendors",

  // Modern Aminos, deactivated
  "/vendors/modern-aminos": "/vendors",
  "/vendor/modern-aminos": "/vendors",

  // GetMelts, removed 2026-09-14
  "/vendors/getmelts": "/vendors",
  "/vendor/getmelts": "/vendors",
  "/coupons/vendor/getmelts": "/coupons",
  "/compare/vendors/getmelts-vs-ion-peptide": "/vendors/ion-peptide",
  "/compare/vendors/getmelts-vs-optimum-formula": "/vendors/optimum-formula",
  "/compare/vendors/getmelts-vs-researchchemhq": "/vendors/researchchemhq",
  "/compare/vendors/getmelts-vs-limitless-biochem": "/vendors/limitless-biochem",
  "/compare/vendors/getmelts-vs-vandl-labs": "/vendors/halfnattys",
  "/compare/vendors/biomyst-labs-vs-getmelts": "/vendors/biomyst-labs",
  "/compare/vendors/disguised-alpha-vs-getmelts": "/vendors/disguised-alpha",
  "/compare/vendors/bhg-labs-vs-getmelts": "/vendors/bhg-labs",
};
